"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class LocalStorage {
  constructor(parseToString, parseToJSON) {
    _defineProperty(this, "parseToString", JSON.stringify);

    _defineProperty(this, "parseToJSON", value => {
      try {
        if (typeof value === 'string') return JSON.parse(value);
        return value;
      } catch (error) {
        return value;
      }
    });

    _defineProperty(this, "getAllKeys", () => Object.keys(localStorage));

    _defineProperty(this, "removeItem", key => localStorage.removeItem(key.toString()));

    if (parseToString) this.parseToString = parseToString;
    if (parseToJSON) this.parseToJSON = parseToJSON;
  }

  clear() {
    localStorage.clear();
  }

  get length() {
    return localStorage.length;
  }

  getItem(key) {
    const value = localStorage.getItem(key.toString());
    return this.parseToJSON(value);
  }

  setItem(key, value) {
    return localStorage.setItem(key.toString(), this.parseToString(value));
  }

}

var _default = LocalStorage;
exports.default = _default;